import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import SalaryCutsDetailActions from '../../../../reducers/modules/hr/salary-cuts-detail/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'hr/salary-cuts-detail'

export default class SalaryCutsDetailMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(SalaryCutsDetailActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      SalaryCutsDetailMiddleware.showOne(dispatch, params);
      dispatch(SalaryCutsDetailActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(SalaryCutsDetailActions.process());
          SalaryCutsDetailMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.view());
        SalaryCutsDetailMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.submit());
        SalaryCutsDetailMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,search){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.submit());
        SalaryCutsDetailMiddleware.saveUpdate(dispatch, params, post,search);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(SalaryCutsDetailActions.delete());
        SalaryCutsDetailMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      SalaryCutsDetailMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-salary-cuts-detail' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsDetailActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        SalaryCutsDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(SalaryCutsDetailActions.list(response.data.result));
          }
        })
        .catch((error) => {
          SalaryCutsDetailMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsDetailActions.view(response.data.result));
        }
      })
      .catch((error) => {
        SalaryCutsDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(SalaryCutsDetailActions.process(),SalaryCutsDetailMiddleware.showlist(dispatch, params));
          SalaryCutsDetailMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsDetailMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsDetailActions.process(),SalaryCutsDetailMiddleware.showlist(dispatch,search));
          dispatch(SalaryCutsDetailActions.success());
          SalaryCutsDetailMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${SalaryCutsDetailMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsDetailActions.process(),SalaryCutsDetailMiddleware.showlist(dispatch,search));
          dispatch(SalaryCutsDetailActions.success());
          SalaryCutsDetailMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(SalaryCutsDetailActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(SalaryCutsDetailActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
